import React, { useState, useEffect, useRef } from "react";
import moment from "moment";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import api from "../../../services/api";
import { IAM_API_BASE_URL_2 } from "../../../services/TapApiUrls";
import Status from "../../../components/ui/Status";
import Loader from "../../../components/ui/Loader/Loader";
import RunningStatusViewModal from "../../assets/action/serviceChecksheet/runningStatus/RunningStatusViewModal";
import DateService from "../../../services/DateService";
import { DisplayListPagination } from "../../../components/TapUi";
import TapHelper from "../../../services/TapHelper";

const ScsEventListModal = ({ isOpen, selectedDate, onClose }) => {
    const [loading, setLoading] = useState(false);
    const [events, setEvents] = useState([]);
    const accessToken = useSelector(state => state.auth.access_token);
    const [meta, setMeta] = useState({});
    const runningStatusModalRef = useRef(null);
    useEffect(() => {
        if (isOpen && selectedDate) {
            fetchScsDetails();
        }
    }, [isOpen, selectedDate]);

    const fetchScsDetails = async (page = 1) => {
        setLoading(true);
        try {
            const headers = { 'Authorization': 'Bearer ' + accessToken };
            const params = {
                search_date_from: selectedDate,
                search_date_to: selectedDate,
                per_page: 20,
                page: page
            };
            const response = await api.server2Api.get(`${IAM_API_BASE_URL_2}/report/service_checksheet_running_status`, {
                params, headers
            });
            const scsData = response.data?.data?.data || [];
            const responseData = response.data?.data || {};

            setMeta(
                TapHelper.pick(responseData, [
                    'from',
                    'to',
                    'total',
                    'last_page',
                    'per_page',
                    'current_page'
                ])
            );

            setEvents(responseData.data || []);
            setEvents(scsData);
        } catch (error) {
            toast.error('Failed to load SCS details');
        } finally {
            setLoading(false);
        }
    };

    const handleScsNameClick = (event) => {
        if (runningStatusModalRef.current && runningStatusModalRef.current.runningStatusModalInit) {
            runningStatusModalRef.current.runningStatusModalInit(event);
        }
    };

    if (!isOpen) return null;


    return (<>
        <div className="modal fade show d-block" >
            <div className="modal-dialog modal-lg">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">
                            SCS Events for  {DateService.dateFormat(selectedDate, 'DD MMM YYYY')}
                        </h5>
                        <button type="button" className="btn-close" onClick={onClose}></button>
                    </div>
                    <div style={{ maxHeight: "500px", overflowY: "auto" }}>
                        <div className="modal-body">
                            {loading ? (
                                <div className="text-center py-3"><Loader /></div>
                            ) : (
                                <table className="table table-bordered table-sm align-middle bg-white mt-2 table-fixed">
                                    <thead className="align-middle table-secondary">
                                        <tr>
                                            <th scope="col" style={{ width: "5%" }} className="text-center">S.No</th>
                                            <th scope="col" style={{ width: "20%" }}>Scs Name</th>
                                            <th scope="col" style={{ width: "20%" }}>Asset Name</th>
                                            <th scope="col" style={{ width: "15%" }} className='text-center'>Due Date</th>
                                            <th scope="col" style={{ width: "15%" }}>Site Name</th>
                                            <th scope="col" style={{ width: "15%" }} className='text-center'>Status</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {events.length > 0 ? (
                                            events.map((event, index) => (
                                                <tr key={event.id || index}>
                                                    <td className='text-center'>
                                                        {((meta.current_page - 1) * meta.per_page) + index + 1}
                                                    </td>
                                                    <td className="mb-1 text-primary fw-bold cursor_pointer"
                                                        onClick={() => handleScsNameClick(event)}>{event.alias_name || '-'}</td>
                                                    <td>{event.asset?.name || '-'}
                                                        ({event.asset?.asset_code || '-'})
                                                    </td>
                                                    <td className='text-center'>
                                                        {event.expected_due_date || "-"}
                                                    </td>
                                                    <td>{event.asset?.site || '-'}</td>
                                                    <td  className="text-center">
                                                        {event.status ?
                                                            <Status color={event?.status?.status_color}>
                                                                {event?.status?.status_text}
                                                            </Status>
                                                            : "-"
                                                        }
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td className="text-center" colSpan={6}>No Record Found</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            )}
                        </div>

                        <div className="mx-3">
                            {events.length > 0 && (
                                <DisplayListPagination
                                    meta={meta}
                                    onPageChange={(e) => fetchScsDetails(e.selected + 1)}
                                />
                            )}
                        </div>
                    </div>

                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" onClick={onClose}>Close</button>
                    </div>
                </div>
            </div>
        </div>
        <RunningStatusViewModal ref={runningStatusModalRef} />
    </>
    );
};

export default ScsEventListModal;